import { StyleSheet } from 'react-native'
import HelperPlatform from 'utils/helper-platform'
import { colorList } from 'utils/colors'

export const FormStyles = StyleSheet.create({
	fieldsWeb: {
		web: 0.75
	},
	
	submit: HelperPlatform.select({
		native: {
		
		},
		web: {
			paddingLeft: '18px',
			flex: 0.25
		}
	}),
	submitSmall: {
		alignItems: 'flex-end'
	},
	
	itemPickerContainer: {
		flexDirection: 'row',
		flexWrap: 'wrap',
	},
	
	itemPickerItem: {
		flex: 1,
		minWidth: 45,
		minHeight: 45,
		width: 45,
		height: 45,
		padding: 5,
		borderColor: colorList.GREY.primary,
		borderWidth: 3,
		borderRadius: 5,
		marginRight: 3,
		marginBottom: 3,
		alignItems: 'center',
		justifyContent: 'center'
	},
	itemPickerItemSelected: {
		borderColor: colorList.ORANGE.primary
	},
	itemPickerItemDisabled: {
		opacity: 0.4
	}
});
